import { useContext, useState } from "react";
import BackButton from "../CommonComponents/BackButton/BackButton";
import { AppContext } from "../Context/AppContext";
import ThemeControl from "../CommonComponents/ThemeControl/ThemeControl";
import "./Health.scss";
import AllTests from "./AllTest";
import Items from "./Items";
import PivotTable from "./PivotTable";
function HealthLayout(props) {
	const { theme } = useContext(AppContext);
	const [currentTable, setCurrentTable] = useState("allTests");
	const tables = ["allTests", "pivotTable"];
	const getCurrentTable = () => {
		let component = null;
		switch (currentTable) {
			case "allTests":
				component = <AllTests />;
				break;
			case "pivotTable":
				component = <PivotTable />;
				break;
			default:
				break;
		}
		return component;
	};
	return (
		<>
			<div className='main-container' color={theme.color} data-type='health'>
				<div
					className='head'
					style={{
						fontSize: `${
							(16 / theme.scaleFactor) * theme.headerFontMultiplier
						}px`,
					}}
				>
					<div className='navigation-header'>
						<BackButton />
					</div>
					<div className='content-header'></div>
					<div className='support-header'>
						<ThemeControl />
					</div>
				</div>
				<div className='body'>
					<div
						className='navigation-column'
						style={{
							fontSize: `${
								(16 / theme.scaleFactor) * theme.bodyLeftFontMultiplier
							}px`,
						}}
					>
						<Items
							tables={tables}
							currentTable={currentTable}
							setCurrentTable={setCurrentTable}
						/>
					</div>
					<div
						className='content-column'
						style={{
							fontSize: `${
								(16 / theme.scaleFactor) * theme.bodyCenterFontMultiplier
							}px`,
						}}
					>
						{getCurrentTable()}
					</div>
					{false ? (
						<div
							className='support-column'
							style={{
								fontSize: `${
									(16 / theme.scaleFactor) * theme.bodyRightFontMultiplier
								}px`,
							}}
						></div>
					) : null}
				</div>
				{/* <div className='footer'>
						<div className='navigation-footer'></div>
						<div className='content-footer'></div>
						<div className='support-footer'></div>
					</div> */}
			</div>
		</>
	);
}
export default HealthLayout;
